import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import {
  Typography,
  Button,
  Grid,
  Box,
  Autocomplete,
  TextField,
  CircularProgress,
} from '@mui/material'
import { Navbar } from '../../component/shared/Navbar'
import AddIcon from '@mui/icons-material/Add'
import Table from './Table'
import { PageContainer } from '../../component/styled/PageContainer'
import moment from 'moment'
import { useExportSalesCommission } from '../../api/sales-commission'
import { useSnackbar } from 'notistack'
import DownloadIcon from '@mui/icons-material/Download'

const getLast12Months = () => {
  const months = []
  const now = moment()

  for (let i = 0; i < 12; i++) {
    const date = moment(now).subtract(i, 'months')
    months.push({ label: date.format('MMMM YYYY'), value: date.format('MMYYYY') })
  }

  return months
}

export const Commission = () => {
  const monthOptions = getLast12Months()
  const [open, setOpen] = useState(false)
  const [monthYear, setMonthYear] = useState(monthOptions[0].value)
  const { mutateAsync: getExport, isLoading: isLoadingExport } = useExportSalesCommission()
  const { enqueueSnackbar } = useSnackbar()

  const handleExport = async () => {
    try {
      const fileName = `Sales_Commission_${monthYear}.xlsx`
      const res = await getExport({ monthYear })
      const url = URL.createObjectURL(res.data)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      enqueueSnackbar('Exported', { variant: 'success' })
    } catch {
      enqueueSnackbar(`Failed to export data`, { variant: 'error' })
    }
  }

  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Sales Commission</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Grid container spacing={2} paddingTop={5}>
          <Grid item xs={12}>
            <Typography variant='h1'>Sales Commission</Typography>
          </Grid>
          <Grid item xs={12} display='flex' gap={2}>
            <Autocomplete
              options={monthOptions}
              value={monthOptions.find((option) => option.value === monthYear)}
              onChange={(_, { value }) => value && setMonthYear(value)}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => <TextField {...params} variant='outlined' fullWidth />}
              fullWidth
              disableClearable={true}
            />
            <Button
              variant='contained'
              color='primary'
              onClick={() => setOpen(true)}
              startIcon={<AddIcon style={{ color: '#FFFFFF' }} />}
              size='large'
            >
              IMPORT
            </Button>
          </Grid>
          <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
            <Button
              startIcon={<DownloadIcon />}
              endIcon={isLoadingExport && <CircularProgress size='1.5rem' />}
              onClick={handleExport}
              disabled={isLoadingExport}
            >
              Export Sales Commission
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Table monthYear={monthYear} open={open} setOpen={setOpen} />
          </Grid>
        </Grid>
      </PageContainer>
    </>
  )
}
